import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import FieldTitle from 'util/FieldTitle';

/**
 * An Input component for a select box, using an array of objects for the options
 *
 * Choices are collected from server reply dynamically.
 * @example
 * const choices = get(record, choiceSource)
 *
 * By default, the options are built from:
 *  - the 'id' property as the option value,
 *  - the 'name' property an the option text
 * @example
 * const choices = [
 *    { id: 'M', name: 'Male' },
 *    { id: 'F', name: 'Female' },
 * ];
 *
 * The object passed as `options` props is passed to the material-ui <SelectField> component
 */
export class SelectInputFromData extends Component {
    handleChange = (event, index, value) => this.props.input.onChange(value);

    renderMenuItem = (choice) => {
        const {
            optionText,
            optionValue,
        } = this.props;
        const choiceName = React.isValidElement(optionText) ? // eslint-disable-line no-nested-ternary
            React.cloneElement(optionText, { record: choice }) :
            (typeof optionText === 'function' ?
                optionText(choice) :
                choice[optionText]
            );
        return (
            <MenuItem
                key={choice[optionValue]}
                primaryText={choiceName}
                value={choice[optionValue]}
            />
        );
    }

    render() {
        const {
            allowEmpty,
            elStyle,
            input,
            isRequired,
            label,
            meta: { touched, error },
            options,
            resource,
            source,
            choiceSource,
            record,
        } = this.props;

        const choices = get(record, choiceSource);

        return (
            <SelectField
                value={input.value}
                floatingLabelText={<FieldTitle label={label} source={source} resource={resource} isRequired={isRequired} />}
                onChange={this.handleChange}
                autoWidth
                style={elStyle}
                errorText={touched && error}
                {...options}
            >
                {allowEmpty &&
                    <MenuItem value={null} primaryText="" />
                }
                {choices && choices.map(this.renderMenuItem)}
            </SelectField>
        );
    }
}

SelectInputFromData.propTypes = {
    addField: PropTypes.bool.isRequired,
    allowEmpty: PropTypes.bool.isRequired,
    choices: PropTypes.arrayOf(PropTypes.object),
    elStyle: PropTypes.object,
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.element,
    ]).isRequired,
    optionValue: PropTypes.string.isRequired,
    resource: PropTypes.string,
    source: PropTypes.string,
    choiceSource: PropTypes.string.isRequired,
    record: PropTypes.object,
};

SelectInputFromData.defaultProps = {
    addField: true,
    allowEmpty: false,
    choices: [],
    options: {},
    optionText: 'name',
    optionValue: 'id',
};

export default SelectInputFromData;



// WEBPACK FOOTER //
// ./src/components/input/SelectInputFromData.js